import React from 'react';
import Select from '../Select';

const SelectField = ({
  name,
  formik,
  options = [],
  placeholder = 'Select...',
  onBlur = null,
  ...props
}) => (
  <Select
    name={name}
    value={formik.values[name]}
    onChange={formik.handleChange}
    onBlur={onBlur ?? formik.handleBlur}
    error={formik?.touched[name] && formik?.errors[name]}
    {...props}
  >
    <option value="" disabled>
      {placeholder}
    </option>
    {options.map((opt) => (
      <option key={opt.value} value={opt.value}>
        {opt.label}
      </option>
    ))}
  </Select>
);

export default SelectField;
